// Once we get rid of this piece of shit router we can also get rid of this crap
// TODO - REMOVE THIS SHIT

import { Dispatch, Store } from 'redux'
import { redirect } from 'redux-first-router'

import { SharedState } from '~shared-components/redux/sharedState'

import { Page } from './enums'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const redirectToPage = (thunkDispatch: any) => (
  page: Page,
  payload?: object,
) =>
  thunkDispatch(
    (dispatch: Dispatch, getState: Store<SharedState>['getState']) => {
      dispatch(
        redirect({
          payload: Object.assign(payload ? payload : {}, {
            ...getState().location.payload,
          }),
          type: page,
        }),
      )
    },
  )

export const redirectToNotFound = (dispatch: Dispatch) =>
  redirectToPage(dispatch)(Page.NotFound)
